import React, { useContext } from 'react';
import { StringType } from '../sv-strings';

export type Props = {
  strings: StringType;
};

export const useStringsContext = () => useContext(StringsContext);

const StringsContext: React.Context<Props> = React.createContext({
  strings: {},
});

export default StringsContext;
